import React from "react";
import PropTypes from "prop-types";
import styles from "./MultipleChoiceItem.module.css";
import classNames from "classnames";
import CheckedIcon from "../../assets/Approved_Gray.svg";

/**
 * Interactive component. An input button that gives a vote to a given option in a multiple-choice decision item.
 */
export function MultipleChoiceItem({
  isSelected,
  onClick,
  itemPosition,
  itemTitle,
  isEdit,
  onEdit,
}) {
  return (
    <div
      className={classNames(styles.container, {
        [styles["container-checked"]]: isSelected,
      })}
    >
      <label className={styles["checkbox-container"]}>
        <input
          className={styles.checkbox}
          type="checkbox"
          name={`checkbox${itemPosition}`}
          value={itemTitle}
          disabled={true}
          checked={isSelected}
        />
        <span
          className={classNames(styles.checkmark, {
            [styles["checkmark-checked"]]: isSelected,
          })}
          onClick={() => onClick(itemPosition)}
        >
          {itemPosition}
        </span>
      </label>
      <div className={styles.grid}>
        <label
          className={classNames(styles.text, {
            [styles["input-checked"]]: isSelected,
          })}
          htmlFor={`checkbox${itemPosition}`}
          hidden={isEdit}
        >
          {itemTitle}
        </label>
        <label hidden htmlFor="item-title">
          Item Title
        </label>
        <input
          disabled={!isEdit}
          hidden={!isEdit}
          type="text"
          onChange={onEdit}
          placeholder="Choice"
          value={itemTitle}
          className={styles.input}
        />
      </div>
      {isSelected && (
        <img
          src={CheckedIcon}
          alt="Is selected"
          className={styles["check-icon"]}
        />
      )}
    </div>
  );
}

MultipleChoiceItem.propTypes = {
  /**
   * Shows whether the item is selected or not.
   */
  isSelected: PropTypes.bool,
  /**
   * Handles button click.
   */
  onClick: PropTypes.func,
  /**
   * The position of the item
   * Ex: A,B,C or 1,2,3
   */
  itemPosition: PropTypes.string,
  /**
   * Title of the item
   */
  itemTitle: PropTypes.string,
  /**
   * Boolean that determines if the itemTitle is being edited.
   */
  isEdit: PropTypes.bool,
  /**
   * Function that fires when the itemTitle is edited.
   */
  onEdit: PropTypes.func,
};
